import React, { useState, useEffect } from 'react';
import EmprConfigHeaderCard from './EpmrConfigHeader';
import EmptyListPlaceholder from './EmptyListPlaceHolder';
import AddEditConfigDialog from './AddEditConfigDialog';
import ConfigSummaryCard from './ConfigSummaryCard';
import { createEmprConfig, getFormattedEmprConfig, getDropdowns, updateEpmrConfig, deleteEpmrCofig, getConfigs } from './service';
import ALoader from '../../../common/a-loader';
import { successToast } from '../../../common/utils/methods/toasterFunctions/function';
import { fetchBusinessAreasByRegions } from '../../../academicPlanAndTest/constant/common';
import { getDropdownIdsFromSelectArray } from '../../../common/utils/methods/commonMethods/utilityMethod';
import { checkPermission } from '../../../common/utils/methods/commonMethods/utilityMethod';


const EpmrConfigsListing = ({ userPermissions }) => {

  const isCreatePermission = checkPermission(userPermissions, "C");
  const isUpdatePermission = checkPermission(userPermissions, 'U');
  const isDeletePermission = checkPermission(userPermissions, 'D');

  const [form, setForm] = useState(null);
  const [epmrConfigs, setEpmrConfigs] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buLoading, setBuLoading] = useState(false);

  const handleForm = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

  const addConfigHandler = () => setForm({ isNew: true });

  const closeAddEditConfigDialog = () => {
    setForm(null);
    setDropdownData(prev => ({
      ...prev,
      businessAreas: []
    }))
  }

  const addEditConfigDialogOpen = !!form;

  const getAllEpmrConfig = async (dropdowns = dropdownData) => {
    try {
      setLoading(true);
      const emprConfigs = await getConfigs();
      setEpmrConfigs(emprConfigs?.map(config => getFormattedEmprConfig(config, dropdowns)))
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  const init = async () => {
    try {
      setLoading(true);
      const dropdownData = await getDropdowns();
      setDropdownData(dropdownData);
      getAllEpmrConfig(dropdownData)

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }

  }

  const deleteConfigHandler = async (id) => {
    try {
      setLoading(true)
      const resp = await deleteEpmrCofig(id);
      if (resp?.code === 200) {
        successToast("Request completed successfully!");
        getAllEpmrConfig();
      }

    } catch (err) {
      console.log(err);

    } finally {
      setLoading(false);
    }
  }

  const createUpdateConfigHandler = async () => {
    try {
      setLoading(true);
      const resp = await (form?.isNew ? createEmprConfig(form) : updateEpmrConfig(form));
      if (resp?.code === 200) {
        successToast("Request completed successfully!");
        getAllEpmrConfig();
        closeAddEditConfigDialog();
      }

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  const getBuAgainstRegions = async (regions) => {
    try {
      setBuLoading(true);
      let buAgainstRegions = [];

      if (regions?.length > 0) {
        buAgainstRegions = await fetchBusinessAreasByRegions(getDropdownIdsFromSelectArray(regions));
      }
      return buAgainstRegions;

    } catch (err) {
      console.log(err);
    } finally {
      setBuLoading(false);
    }

  }

  const regionChangeHandler = async (regions) => {
    try {
      handleForm("regions", regions)
      const buAgainstRegions = await getBuAgainstRegions(regions);

      setDropdownData(prev => ({
        ...prev,
        businessAreas: buAgainstRegions
      }))

      //intersection of already selected BUs and the new BU dropdown array
      const filteredBUs = form.businessArea?.filter(el => buAgainstRegions?.some(bu => bu?.value === el?.value));
      handleForm("businessArea", filteredBUs);


    } catch (err) {
      console.error(err);
    }
  }

  const editConfigHandler = async config => {
    try {
      setForm(config);
      const buAgainstRegions = await getBuAgainstRegions(config?.regions);
      setDropdownData(prev => ({
        ...prev,
        businessAreas: buAgainstRegions
      }))
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    init();
  }, [])

  return (
    <>
      {loading && <ALoader position="fixed" />}

      <EmprConfigHeaderCard
        addConfigHandler={addConfigHandler}
        isCreatePermission={isCreatePermission}
      />

      {epmrConfigs?.length != 0
        ? <div className='p-3'>
          {epmrConfigs?.map(config =>
            <ConfigSummaryCard
              key={config?.id}
              config={config}
              deleteConfigHandler={deleteConfigHandler}
              editConfigHandler={editConfigHandler}
              isUpdatePermission={isUpdatePermission}
              isDeletePermission={isDeletePermission}
            />)}
        </div>
        : <EmptyListPlaceholder
          addConfigHandler={addConfigHandler}
          isCreatePermission={isCreatePermission}
        />
      }


      <AddEditConfigDialog
        open={addEditConfigDialogOpen}
        handleClose={closeAddEditConfigDialog}
        form={form}
        handleForm={handleForm}
        dropdownData={dropdownData}
        createUpdateConfigHandler={createUpdateConfigHandler}
        regionChangeHandler={regionChangeHandler}
        buLoading={buLoading}
        loading={loading}
      />

    </>
  );
}

export default EpmrConfigsListing;